import { type AnyObject } from '@Types';
import { type IguanaObject } from 'Iguana';

export function isIguanaObject<T extends IguanaObject>(o: T | AnyObject): o is T {
    return '__iguana_type' in o;
}
